import { EmptyDataMessage } from '@/common/components/EmptyDataMessage'
import Table from '@/common/components/Table'
import { maintenancePieceAdditionalInformationDefaultColumns } from '@/features/maintenance/features/workflows/features/diagnosticEntry/screens/Update/constants/maintenancePieceAdditionalInformationDefaultColumns.constant'
import { MaintenanceEquipmentPieceAdditionalInformation } from '@/features/maintenance/features/workflows/types/maintenanceEquipmentPiece.type'

interface MaintenancePieceAdditionalInformationTableProps {
  additionalInformation: MaintenanceEquipmentPieceAdditionalInformation[]
  isLoading?: boolean
}

const MaintenancePieceAdditionalInformationTable = ({
  additionalInformation,
  isLoading = false,
}: MaintenancePieceAdditionalInformationTableProps) => {
  if (!isLoading && !additionalInformation?.length) {
    return <EmptyDataMessage className="h-40" imageHeight={120} />
  }

  return (
    <Table
      columns={maintenancePieceAdditionalInformationDefaultColumns}
      rows={additionalInformation?.map((info) => ({ ...info, _className: 'sm:py-2' })) || []}
      isLoadingData={isLoading}
      hasPagination={false}
      page={1}
      totalPages={1}
      loadingRows={1}
      className="w-full max-h-28"
      headerClassName="hidden"
      footerClassName="hidden"
    />
  )
}

export default MaintenancePieceAdditionalInformationTable
